
import CheckIcon from 'vux/src/components/check-icon/index.vue'

import Popup from 'vux/src/components/popup/index.vue'

import XTable from 'vux/src/components/x-table/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Search from 'vux/src/components/search/index.vue'

export default {
name: "search-search",
components: {
Popup,
CheckIcon,
XTable,
PopupHeader,
Search
},
data() {
return {
value: null,
divMask: null,
wlPopup: null,
dto: null,
list: [],
show: false,
showBottom: false,
page: 0,
chooseData:null,
dialogValue:null,
searchData:{},
supplier:{
url:'api/supplier',
searchCondition:{'label':'供应商名称','value':'supplierName'},
item:[{label:'供应商编号',value:'supplierCode'},{label:'供应商名称',value:'supplierName'}]
},
purOrg:{
url:'api/purorg',
searchCondition:{'label':'采购组织名称','value':'purorgName'},
item:[{label:'采购组织编号',value:'purorgCode'},{label:'采购组织名称',value:'purorgName'}]
},
person:{
url:'api/person',
searchCondition:{'label':'姓名','value':'name'},
item:[{label:'姓名',value:'name'},{label:'编号',value:'code'}]
},
address:{
url:'api/address',
searchCondition:{'label':'联系人姓名','value':'linkman'},
item:[{label:'联系人姓名',value:'linkman'},{label:'地址名称',value:'name'},{label:'联系人电话',value:'linkmanPhone'}]
},
plant:{
url:'api/plant',
searchCondition:{'label':'工厂名称','value':'plantName'},
item:[{label:'工厂编号',value:'plantCode'},{label:'工厂名称',value:'plantName'}]
},
assPlant:{
url:'api/sup-ass-plan',
searchCondition:{'label':'考核方案代码','value':'code'},
item:[{label:'方案代码',value:'code'},{label:'方案名称',value:'name'},{label:'总分值',value:'totalScore'},{label:'及格分值',value:'passingScore'}]
},
}
},




props:['multiple','searchBaseData','text','condition',],
methods: {

showPop() {
this.show = true;
if(this.show){
this.page = 0;
this.showBottom = false;
this.value = null;
this.list = [];
this.chooseData = null;
this.getList();
}
this.getElement()
},
delSearch(){
this.dialogValue='';
this.$emit('on-clear')
},
clear(){
this.value=null;
delete this.searchData[this[this.condition].searchCondition['value']];
this.getList();
},
getList() {
if(this.value){
this.searchData[this[this.condition].searchCondition['value']]=this.value;
if(this.searchBaseData){
this.searchData=Object.assign(this.searchData,this.searchBaseData)
}
}else {
delete this.searchData[this[this.condition].searchCondition['value']];
}
this.$loadingShow();
this.$search(this[this.condition].url,{page: 0, size: 10},this.searchData).then(data => {
this.$loadingHide();
data = data.filter((item) => {
return !item.deleted;
});
if(this.condition === 'purOrg' || this.condition === 'plant'){
data = data.filter((item) => {
return item.enabled;
})
}
this.list = this.list.concat(data);
if(data.length < 10){
this.showBottom = true;
}else {
this.showBottom = false;
}
}).catch(err=> this.$loadingHide()
)
},
getMore(){
this.page++;
if(this.value){
this.searchData[this[this.condition].searchCondition['value']]=this.value;
if(this.searchBaseData){
this.searchData=Object.assign(this.searchData,this.searchBaseData)
}
}else {
delete this.searchData[this[this.condition].searchCondition['value']];
}
this.$loadingShow();
this.$search(this[this.condition].url,{page: this.page, size: 10},this.searchData).then(data => {
this.$loadingHide();
data = data.filter((item) => {
return !item.deleted;
});
if(this.condition === 'purOrg' || this.condition === 'plant'){
data = data.filter((item) => {
return item.enabled;
})
}
this.list = this.list.concat(data);
if(data.length < 10){
this.showBottom = true;
}else {
this.showBottom = false;
}
}).catch(err=> this.$loadingHide()
)
},

searchList(){
this.page = 0;
this.list = [];
this.chooseData = null;
this.getList();
},

choose(data){
if(this.multiple){
if(data.checkSelected){
if(!this.chooseData){
this.chooseData = [];
}
this.chooseData.push(data);
}else{
let dataList = [];
for(let i=0;i<this.chooseData.length;i++){
if(data.id !== this.chooseData[i].id){
dataList.push(this.chooseData[i]);
}
}
this.chooseData = dataList;
}
}else{
if(data.checkSelected){
if(this.chooseData){
this.$set(this.chooseData,'checkSelected',false);
}
this.chooseData = data;
}else{
this.chooseData = null;
}
}
},

goBack(){
if(this.multiple){
if(!this.chooseData || !this.chooseData.length){
this.$vux.toast.text('请选择数据');
return;
}
}else{
if(!this.chooseData){
this.$vux.toast.text('请选择数据');
return;
}
}
this.dialogValue=this.chooseData[this[this.condition].searchCondition.value];
this.$emit('on-confirm',this.chooseData)
this.show=!this.show;
},
hide(){
let popup=document.getElementById(this.wlPopup);
popup.parentElement.removeChild(this.divMask)
},
getElement(){
this.$nextTick(()=>{
let el=document.getElementsByClassName('vux-popup-mask vux-popup-show')[0];
if(el){
document.body.removeChild(el)
}
let popup=document.getElementById(this.wlPopup);
this.divMask=document.createElement('a')
this.divMask.className = 'vux-popup-mask'
this.divMask.dataset.uuid = ''
this.divMask.href = 'javascript:void(0)'
this.divMask.style.opacity=1;
this.divMask.style['z-index']=1;
this.divMask.addEventListener('click',  () =>{
this.show=false;
}, false)
popup.parentElement.appendChild(this.divMask)

})
}
},
mounted() {
this.wlPopup=(Math.random()+1)*10+'red';
this.dto=this[this.condition];
}
}



// WEBPACK FOOTER //
// ./src/components/search-search.vue